(function () {
	angular
		.module('trackeye')
		.controller('PositionsController', PositionsController);

	PositionsController.$inject = ["$scope", "$translate", "AccountService", "DeviceService", "NotificationService", "PositionsService", "ModalService", "AppFactory", "C4ApiService", "EventIconMeta"];

	function PositionsController($scope, $translate, AccountService, DeviceService, NotificationService, PositionsService, ModalService, cfg, api, EventIconMeta) {
		var vm = this;

		// load indicator
		vm.is_triangulating = false;

		/**
		 * Selected device
		 * @type {Device}
		 */
		vm.device = DeviceService.getSelectedDevice();

		/**
		 * Selected sutmessage
		 * @type {SutMessage}
		 */
		vm.message = DeviceService.getSelectedMessage();

		/**
		 * Sutmessages for selected device
		 * @type {SutMessage[]}
		 */
		vm.messages = vm.device.sutmessages.all();

		/**
		 * @type {Account}
		 */
		vm.account = AccountService.get();

		/**
		 * @type {Date}
		 */
		vm.today = new Date();

		vm._isWorking = false;

		var searchModal = ModalService.create('search-positions');

		vm.showSearchPositions = function() {
			if (vm.isSearched()) {
				vm.isSearched(false);
				vm.messages = vm.device.sutmessages.all();
			} else {
				searchModal.linkScope(vm);
				searchModal.open();
			}
		};

		/**
		 * Search for positions by a given date
		 * @param {Date} date_from
		 * @param {Date} date_to
		 */
		vm.search_positions = function(date_from, date_to) {

			var is_timeframe_valid = !((Math.abs(date_from - date_to) / 3600000) > 168);
			searchModal.scope.searchForm.$setValidity('timeframe', is_timeframe_valid);
			searchModal.scope.searchForm.$setValidity('nopositions', true)

			if (!searchModal.scope.searchForm.$valid)
				return;

			vm.isWorking(true);

			var date_end, date_begin;

			if (date_from > date_to) {
				date_end = date_from;
				date_begin = date_to;
			} else {
				date_begin = date_from;
				date_end = date_to;
			}

			var end_y = date_end.getFullYear(),
				end_m = date_end.getMonth(),
				end_d = date_end.getDate(),
				begin_y = date_begin.getFullYear(),
				begin_m = date_begin.getMonth(),
				begin_d = date_begin.getDate(),
				begin = new Date(begin_y, begin_m, begin_d, 0, 0, 0, 0),
				end = new Date(end_y, end_m, end_d, 23, 59, 59, 999);

			vm.device.searchMessages(begin, end).then(function (resp) {
				vm.isSearched(true);
				vm.messages = resp.all();
				searchModal.close();
			}, function() {
				searchModal.scope.searchForm.$setValidity('nopositions', false)
			}).finally(function() {
				vm.isWorking(false);
			});
		};

		vm.isWorking = function(value) {
			if (angular.isDefined(value))
				vm._isWorking = value;

			return vm._isWorking;
		};

		vm.showList = function () {
			//logUnique('showList');
			return DeviceService.hasSutDevices() && vm.device.isLoaded() && vm.device.sutmessages.anyGood();
		};
		/**
		 * Fetch more positions, if the device is not working
		 * @returns {void}
		 */
		vm.loadMorePositions = function () {
			if (!vm.device.working())
				vm.device.loadMoreMessages();
		};

		vm.isSearched = function(value) {
			if (angular.isDefined(value))
				PositionsService.searched(value);

			return PositionsService.searched();
		};

		/**
		 * Reset the search
		 */
		vm.resetSearch = function () {
			PositionsService.searched(false);
			vm.messages = vm.device.sutmessages.all();
		};

		vm.csvFilename = function() {
			return vm.device.getNodeId();
		}

		vm.csvHeaders = function() {
			var headers = [
				$translate.instant('STR_CSV_DATE'),
				$translate.instant('STR_CSV_CITY'),
				$translate.instant('STR_CSV_ADDRESS'),
				$translate.instant('STR_CSV_LAT'),
				$translate.instant('STR_CSV_LON'),
				$translate.instant('STR_CSV_POS_TYPE'),
				$translate.instant('STR_CSV_TYPE')
			];

			if (vm.device.hasBatteryIndicator()) {
				headers.push($translate.instant('STR_CSV_BATTERY'))
			}

			if (vm.device.features.hasTemperatureSensor()) {
				headers.push($translate.instant('STR_CSV_TEMPERATURE'))
			}

			if (vm.device.features.isPower()) {
				headers.push($translate.instant('STR_CSV_IGNITION'))
				headers.push($translate.instant('STR_CSV_AUXILIARY'))
			}

			return headers;
		}
		/**
		 * Renders the current position list, as CSV
		 * @returns {Array}
		 */
		vm.csvRenderRows = function () {
			var feat = vm.device.features,
				state = {
					useBatteryIcon: feat.useBatteryIcon(),
					hasTemperatureSensor: feat.hasTemperatureSensor(),
					isPower: feat.isPower()
				};

			var bareMessages = [];
			for (var i = 0; i < vm.messages.length; i++) {
				var row = {},
					message = vm.messages[i];

				row.date = moment(message.getTsWithTimezone()).format(vm.account.getDatetimeFormat());

				if (message.hasLonLat()) {
					row.city = message.getAddress('country', "") + " " + message.getAddress('town', "") || null;
					if (message.isGPS()) {
						row.address = message.getAddress('street.name', "") + " " + message.getAddress('street.building.number', "") || null;
					} else {
						row.address = "";
					}
					row.latitude = message.getLat(5)
					row.longitude = message.getLon(5)
					row.pos_type = message.isGPS() ? 'GPS' : 'GSM';
				} else {
					row.city = "";
					row.address = "";
					row.latitude = "";
					row.longitude = "";
					row.pos_type = "";
				}

				var meta = EventIconMeta.getMeta(message, vm.messages[i+1], vm.device);
				row.type = $translate.instant(meta.title);

				if (meta.title_addition) {
					row.type += ", " + $translate.instant(meta.title_addition)
				}

				if (state.useBatteryIcon) {
					row.battery = message.getBatteryCapacity()+'mV';
				} else if (message.consumption.capacityPercentage) {
					row.battery = message.consumption.capacityPercentage+'%'
				}

				if (state.hasTemperatureSensor) {
					row.temp = message.getTemperature() + "°C"
				}

				if (state.isPower) {
					var timeI1 = message.getHourValueI1(),
							timeI2 = message.getHourValueI2();

					row.ignition = timeI1[0]+'t '+timeI1[1]+'m';
					row.auxiliary = timeI2[0]+'t '+timeI2[1]+'m';
				}

				bareMessages.push(row);
			}

			return bareMessages;
		};

		/**
		 * Checks if a message is relevant, more info at
		 * https://git.care4all.dk/care4all/trackeye/issues/69
		 * @param {SutMessage} message
		 * @returns {boolean}
		 */
		vm.isMessageRelevant = function (message) {
			var uaps = ["1005"],
				hasUap = (uaps.indexOf(vm.device.getUap()) >= 0);

			return !(hasUap && !message.hasLonLat());

		};

		vm.getAddressCellTitle = function (message) {
			if (message.isLastGood())
				return "STR_IS_LASTGOOD_GPS";

			return '';
		};

		/**
		 * Message cannot be triangulated, as the current location data
		 * is already fetched by triangulation.
		 *
		 * @param {SutMessage} message
		 * @returns {bool}
		 */
		vm.canBeTriangulated = function (message) {
			if (!message.isTriangulated() && message.isGSM())
				return false;

			return true;
		};

		vm.showTriangulateButton = function(message) {
			if (vm.device.features.isCapture() || vm.device.features.isRapid()) {
				if ((message.isLastGood() || !message.hasLocation())
					&& vm.isMessageSelected(message)
					&& vm.canBeTriangulated(message)
				) {
					return true;
				}
			}

			return false;
		}

		vm.getPositionByTriangulation = function (message) {
			if (message.isTriangulated()) {
				message.setTriangulationActive(!message.isTriangulationActive());
			} else {
				vm.is_triangulating = true;
				api.triangulate(vm.device.getNodeId(), message.getRawGSM()).then(function(xhr) {
					message
						.setTriangulated(xhr.getResponseData())
						.setTriangulationActive(true);

					vm.showPosition(message);

				}, function() {
					NotificationService.warning('STR_COULD_NOT_FETCH_BY_TRIANGULATION');
				}).finally(function() {vm.is_triangulating = false;});
			}
		}

		vm.isLastGood = function (message) {
			if ( message.isLastGood() && (vm.device.features.isCapture() || vm.device.features.isPoliceRapid()) )
				return true;

			return false;
		}

		vm.renderTsWithTimezone = function(ts) {
			return moment(ts).format();
		};

		/**
		 *
		 * @param {SutMessage} message
		 * @returns {*}
		 */
		vm.renderLocationText = function (message) {
			if (message.isTriangulationActive()) {
				return message.getTriangulatedAddress();
			} else if (message.hasLocation()) {
				if (message.isByEchoHeard()) {
					var tag = vm.device.getTagById(message.getEchoNumber());
					return tag ? tag.getDescription() : message.getEchoNumber();
				} else {
					return vm.isMessageSelected(message) ? message.getParsedAddress(0) : message.getParsedAddress(24);
				}
			} else {
				return $translate.instant('STR_NO_POSITION');
			}
		};

		vm.getDateFormat = function() {
			return 'DD/MM/YYYY HH:mm';
		};

		/**
		 * Show the passed position on the map.
		 * @param {SutMessage} message
		 */
		vm.showPosition = function (message) {
			setSelectedMessage(message);
			PositionsService.setMessage(message);
		};

		/**
		 *
		 * @param {SutMessage} message
		 * @returns {boolean}
		 */
		vm.isMessageSelected = function (message) {
			if (vm.message)
				return message.id === vm.message.id;

			return false;
		};

		/**
		 * Render a message, dependeted on the device state.
		 * @returns {string}
		 */
		vm.renderPositionsInfoMessage = function () {
			//logUnique('renderPositionsInfoMessage')
			if (DeviceService.isInitializing()) {
				return "STR_IS_STARTING_UP"
			} else if (!DeviceService.hasSutDevices()) {
				return "STR_NO_DEVICES";
			} else if (vm.device.working()) {
				return "STR_DEVICE_IS_LOADING";
			} else if (!vm.messages.length || !vm.device.sutmessages.anyGood()) {
				return "STR_DEVICE_HAS_NO_POSITIONS";
			}
		};

		vm.getPositionsInfoMessageClass = function () {
			//logUnique('getPositionsInfoMessageClass')
			if (vm.device.working())
				return 'is-info';

			if (!vm.messages.length || !vm.device.sutmessages.anyGood())
				return 'is-warning';
		}

		/**
		 * Renders column head text, depending on device feature.
		 * @param {SutMessage} message - to check for existing temperature property
		 * @returns {*}
		 */
		vm.renderMeasureHeadText = function (message) {
			//logUnique('renderMeasureHeadText');
			var feat = vm.device.features;

			if (feat.isCapture())
				return undefined;

			if (feat.isPower())
				return $translate.instant('STR_POWER_ACTIVE');

			if (feat.hasDistanceMeter())
				return $translate.instant('STR_DISTANCE');

			if (message.hasTemperature())
				return "°"+"C"

		};
		/**
		 * Determine if the battery column should be shown.
		 * @returns {boolean}
		 */
		vm.showBatteryColumn = function () {
			//logUnique('showBatteryColumn');
			var feat = vm.device.features;
			return (
				!!vm.device &&
				!feat.isCapture() &&
				!feat.isPower() &&
				!vm.device.hasBatteryStateIndicator()
			)
		};

		/**
		 * Determines if the measurement column should be shown.
		 * @param {SutMessage} message - to check for existing temperature property
		 * @returns {boolean}
		 */
		vm.showMeasurementColumn = function (message) {
			//logUnique('showMeasurementColumn');
			var feat = vm.device.features;

			return (
				!!vm.device &&
				!feat.isCapture()
			);
		};

		/**
		 * Determines if the measurement column should be shown.
		 * @param {SutMessage} message - to check for existing temperature property
		 * @returns {boolean}
		 */
		vm.showAmbientMeasurementColumn = function (message) {
			// console.log(vm.device);
			const feat = vm.device.features;
			return (!!vm.device && !feat.isCapture() && vm.device.latest.hasI2CTemperature() && vm.device.latest.hasTemperature());
		}

		/**
		 * Determines if the humidity column should be shown.
		 * @param {Array<SutMessage>} messages - to check for existing temperature property
		 * @returns {boolean}
		 */
		vm.showHumidityColumn = function (messages) {
			let showColumn = false;
			messages.forEach(message => {
				if (message.hasHumidity())
					showColumn = true;
			});
			return showColumn;
		}

		/**
		 * Gets a measurement from the message, or n/a.
		 * @param {SutMessage} message
		 * @returns {string|undefined}
		 */
		vm.getMeasurement = function (message) {
			//logUnique('getMeasurement');
			// console.log(message);
			var feat = vm.device.features;
			if (feat.isCapture())
				return '-';

			if (feat.isPower()) {
				var hour = 'h',
						min = 'm';

				if (vm.account.getLocale() == 'da') {
					hour = 't'
				}

				var time = message.getHourValueI1();
				return time[0]+hour+' '+time[1]+min;
			}

			if (feat.hasDistanceMeter())
				return vm.device.getDistance(message) + " " + feat.getDistanceUnit();

			if (message.hasI2CTemperature()) {
				return Math.round(message.getI2CTemperature() * 10) / 10 + " °"+"C";
			}

			if (message.hasTemperature())
				return message.getTemperature() + " °"+"C";

			return "-";
		};

		/**
		 * Gets a measurement from the message, or n/a.
		 * @param {SutMessage} message
		 * @returns {string|undefined}
		 */
		vm.getAmbientTemperature = function (message) {
			if (message.hasTemperature()) {
				return message.getTemperature() + " °"+"C";
			}
			return '-';
		}

		/**
		 * Gets a humidity from the message, or n/a.
		 * @param {SutMessage} message
		 * @returns {string|undefined}
		 */
		vm.getHumidity = function (message) {
			if (message.hasHumidity())
				return message.getHumidity() + '%';

			return '-';
		}

		/**
		 * Returns a CSS class matching the current temperature boundaries
		 * @param {SutMessage} message
		 * @returns {string|null}
		 */
		vm.getMeasurementClass = function (message) {
			//logUnique('getMeasurementClass');
			var device = vm.device;

			if (device.features.hasDistanceMeter() || device.features.isPower())
				return null;

			const temp = device.latest.hasI2CTemperature() ? message.getI2CTemperature() : message.getTemperature();

			if (temp && device.hasTemperatureBoundaries()) {
				if (device.isTemperatureLow(temp)) {
					return "temp-cold";
				} else if (device.isTemperatureHigh(temp)) {
					return "temp-hot";
				}
				return "temp-good";
			}

			return null;
		};

		// Event methods
		/**
		 * @param {Object} event
		 * @param {Device} device
		 */
		function onDeviceSelected(event, device) {
			setSelectedMessage(device.latest);
			vm.messages = device.sutmessages.all();
			vm.device = device;

			refreshState()
		}

		function refreshState() {

		}

		/**
		 * @param {Object} event
		 * @param {Device} device
		 */
		function onDeviceData(event) {
			if (!vm.isSearched() && vm.device.latest.hasLonLat()) {
				setSelectedMessage(vm.device.latest);
			}
		}

		// Event listeners
		$scope.$on('DeviceService.selected', onDeviceSelected);
		$scope.$on('DeviceService.data', onDeviceData);

		// Private helpers

		function setSelectedMessage(message) {
			vm.message = message;
			DeviceService.setSelectedMessage(message);
		}
	}
})();
